
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help",
      function () {
        return require("private-next-pages/help.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help"])
      });
    }
  